<template>
        <div>
          <div class="text-body-2">
            By checking the ACH Debit box above, I (we) hereby authorize Upstate Coin &amp; Gold (“<b>UPSTATE</b>”),
            to electronically
            debit my (our) account indicated above (“<b>ACCOUNT</b>”) at the depository financial institution
            named above
            (“<b>DEPOSITORY</b>”) for the payment of all of my (our) obligations to UPSTATE (and its affiliates)
            and, if necessary, to
            electronically credit my (our) ACCOUNT at the DEPOSITORY to correct any erroneous debits. UPSTATE is
            authorized to debit my (our) ACCOUNT for any amounts owed to UPSTATE and its affiliates.
          </div>
          <div class="text-body-2 pt-5">
            By checking the ACH Payment box above, I (we) hereby authorize UPSTATE to electronically credit my
            (our)
            ACCOUNT for the payment of all obligations from UPSTATE (and its affiliates) to me (us) and, if
            necessary, to
            electronically debit my (our) ACCOUNT at the DEPOSITORY to correct any erroneous credits. UPSTATE is
            authorized to credit my (our) ACCOUNT for any amounts owed to me (us) by UPSTATE and its affiliates.
          </div>
          <div class="text-body-2 pt-5">
            I (we) acknowledge the origination of automated clearing house (“<b>ACH</b>”) transactions to my (our)
            ACCOUNT must
            comply with the provisions of U.S. law and I (we) agree not to dispute UPSTATE’S debit charges to my
            (our)
            ACCOUNT with the DEPOSITORY so long as the transactions correspond to the terms indicated in this
            authorization form.
          </div>
          <div class="text-body-2 pt-5">
            I (we) understand and agree that any and all changes in my (our) ACCOUNT information, including
            requests to
            terminate this ACH approval, must be provided to UPSTATE through PlatformGold® or through a separate
            authorization which may be obtained by contacting <a target="_blank" href="mailto: accounting@upstatecoins.com">
            accounting@upstatecoins.com</a>, at least 10 business days prior to any requested change taking effect.
          </div>
          <div class="text-body-2 pt-5">
            If the payment due date falls on a weekend or holiday, I (we) understand and agree that the payment
            may be executed on the next business day.
          </div>
          <div class="text-body-2 pt-5">
            I (we) understand and agree that, since this is an electronic transaction, adequate funds must be
            available for
            withdrawal from my (our) ACCOUNT by the date the ACH transaction is initiated. In the case of an ACH
            transaction
            being rejected for non-sufficient funds (“<b>NSF</b>”), submission error, cancellation or other bank
            related return
            reasons, I (we) understand and agree that UPSTATE may at its discretion resubmit the ACH debit
            transaction
            within thirty (30) days. I (we) understand and agree that, in accordance with the Upstate Coin &amp;
            Gold
            PlatformGold® Terms and Conditions <a target="_blank" href="https://platform.gold/#/terms">https://platform.gold/#/terms</a>,
            a fee of up to $50 will be charged for each NSF transaction, which may be initiated as a separate ACH
            transaction from the initial
            authorized payment. I (we) also understand and agree that UPSTATE reserves the right to recover any
            losses related to a rejected
            or cancelled
            ACH transaction, including, but not limited to, market losses and changes in product premiums, as well
            as a
            $39.50 cancellation fee to cover the administration costs associated with offsetting the original
            transaction. I (we)
            agree that such charges may be initiated in a separate transaction from the initial authorized
            payment.
            I (we) understand and agree that UPSTATE shall not have any liability and shall be held harmless in
            the event an
            ACH credit transaction to my (our) ACCOUNT is rejected as a result of a submission error or other bank
            related
            reasons.
          </div>
          <div class="text-body-2 pt-5">
            By clicking “SUBMIT” below, I (we) agree to the above terms and conditions.
          </div>
          <div class="text-body-2 pt-5">
            <b>Disclaimer</b>: The bank account will not be active until confirmed by a member of UPSTATE’S
            accounting team.
            Trades may still be submitted, however, any trades submitted prior to confirmation of updated bank
            account
            details will be subject to the previous payment method.
          </div>
      </div>
</template>

<script>
export default {
  data() { return {}}
}
</script>
